import { memo } from 'react'
import { trackGalleryImageClick } from '../../utils/analytics'
import { useImageErrorHandler } from '../../hooks/useImageErrorHandler'

/**
 * EntityGalleryStrip - Horizontal scrolling thumbnail strip for entity images.
 * Replaces the full 3-col grid in expanded panel mode for a more compact footprint.
 * @idempotent @atomic
 */
const EntityGalleryStrip = memo(function EntityGalleryStrip({ images = [], entityId, onImageClick }) {
  const handleImageError = useImageErrorHandler()

  if (!images || images.length === 0) return null

  return (
    <div className="p-2 bg-primary/5 rounded-lg border border-primary/20 mb-2">
      <div
        className="flex gap-2 overflow-x-auto"
        style={{ scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}
      >
      {images.map((image, idx) => (
        <button
          key={image.id}
          type="button"
          onClick={() => {
            trackGalleryImageClick(entityId, image.id, image.isPrimary, idx)
            onImageClick?.(image, idx)
          }}
          onTouchEnd={(e) => {
            e.preventDefault()
            trackGalleryImageClick(entityId, image.id, image.isPrimary, idx)
            onImageClick?.(image, idx)
          }}
          className="flex-none w-16 h-16 rounded-lg overflow-hidden bg-white/50 border border-primary/10 relative focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 hover:border-primary/40 transition-colors"
        >
          {image.isPrimary && (
            <span className="absolute top-0.5 right-0.5 z-10 bg-yellow-400 rounded-full p-0.5">
              <svg className="w-2.5 h-2.5 text-white fill-current" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </span>
          )}
          <img
            src={image.imageUrl}
            alt=""
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        </button>
      ))}
      </div>
    </div>
  )
})

export default EntityGalleryStrip
